module.exports = __webpack_public_path__ + "img/b4.71a13be4.png";